export default __webpack_public_path__ + "static/media/MP5_9.098efc48.png";